<template lang='pug'>
  div(:class='`input-${name}`')
    template(v-if="type === 'cep'")
      the-mask.input(
        v-model="valueInput"
        type="tel"
        :id="id"
        :class="[className, `h-${size}`]"
        :disabled="disabled"
        :name="name"
        :value="valueInput"
        :autocomplete="autocomplete"
        :maxlength="maxlength"
        :placeholder="placeholder"
        :mask="['#####-###']"
        @input="onInput($event)"
        @focus="onFocus($event.target.value)"
      )
      span.help Não sabe seu CEP? #[br] #[a.help__link(href="http://www.buscacep.correios.com.br/sistemas/buscacep/" target="_blank") Consulte aqui]
    template(v-else-if="type === 'cpf'")
      the-mask.input(
        v-model="valueInput"
        type="tel"
        :id="id"
        :class="[className, `h-${size}`]"
        :disabled="disabled"
        :name="name"
        :value="valueInput"
        :autocomplete="autocomplete"
        :maxlength="maxlength"
        :placeholder="placeholder"
        :mask="['###.###.###-##']"
        @input="onInput($event)"
        @focus="onFocus($event.target.value)"
      )
      span.help já possui cadastro? #[br] #[a.help__link Buscar cadastro]
    the-mask.input(
      v-else-if="mask"
      v-model="valueInput"
      :type="type"
      :id="id"
      :class="[className, `h-${size}`]"
      :disabled="disabled"
      :name="name"
      :placeholder="placeholder"
      :value="valueInput"
      :autocomplete="autocomplete"
      :maxlength="maxlength"
      :mask="mask"
      :tokens="tokens"
      @input="onInput($event)"
      @focus="onFocus($event.target.value)"
    )
    input.input(
      v-else
      v-model="valueInput"
      :id="id"
      :class="[className, `h-${size}`]"
      :disabled="disabled"
      :type="type"
      :name="name"
      :maxlength="maxlength"
      :placeholder="placeholder"
      :autocomplete="autocomplete"
      :value="valueInput"
      @input="onInput($event.target.value)"
      @focus="onFocus($event.target.value)"
    )
</template>

<script>
export default {
  name: 'Input',
  props: {
    type: {
      type: String,
      default: 'text',
      validator: value => value.match(/(text|number|email|money|cep|tel|checkbox|radio|search|cpf)/)
    },
    placeholder: {
      type: String,
      default: null
    },
    id: {
      type: String,
      default: null
    },
    className: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    autocomplete: {
      type: String,
      default: 'on'
    },
    value: {
      default: null
    },
    mask: {
      default: null
    },
    tokens: {
      type: Object,
      default: () => {
        return {
          '#': { pattern: /\d/ },
          // eslint-disable-next-line quote-props
          'X': { pattern: /[0-9a-zA-Z]/, transform: v => v.toLocaleUpperCase() },
          '!': { escape: true }
        }
      }
    },
    maxlength: {
      type: Number,
      default: null
    },
    size: {
      type: String,
      default: 'medium'
    }
  },
  data () {
    return {
      valueInput: this.value,
      filled: false
    }
  },
  watch: {
    value (oldValue, newValue) {
      if (oldValue !== newValue) {
        this.valueInput = oldValue
        this.onInput(this.valueInput)
      }
    }
  },
  created () {
    if (this.value) this.filled = true
  },
  updated () {
    if (this.value) this.filled = true
  },
  methods: {
    onInput (value) {
      value !== '' ? this.filled = true : this.filled = false
      this.$emit('onChange', value?.trim())
    },
    onFocus (value) {
      this.$emit('focus', value)
    }
  }
}
</script>
<style lang="scss" scoped>
  @import "@/assets/style/_variables";

  .input {
    background-color: #ffffff;
    border: solid 1px #bdc2c6;
    border-radius: 8px;
    color: #444444;
    font-family: $rubik-font-family;
    font-size: 16px;
    padding: 12px 16px;
    transition: border-color 400ms;
    width: 100%;

    &[type="search"] {
      -webkit-appearance: none;

      &::-webkit-search-cancel-button {
        -webkit-appearance: none;
        appearance: none;
        cursor: pointer;
        background-image: url('~@/assets/icons/close.svg');
        background-position: center;
        height: 16px;
        width: 16px;
      }
    }

    &:active,
    &:focus {
      outline: none;
    }

    &::placeholder,
    &::-webkit-input-placeholder,
    &::-moz-placeholder,
    &::-ms-input-placeholder { color: rgba(142, 142, 147, 0.6); }

    &:-webkit-autofill {
      -webkit-box-shadow: 0 0 0px 1000px white inset;
      background-color: transparent;
    }

    &--error & {
      border-color: #ff3b30;
    }

    &--success {
      position: relative;

      &::before {
        background-image: url('~@/assets/icons/success-with-circle.svg');
        content: '';
        height: 24px;
        position: absolute;
        right: 16px;
        top: calc(50% - 12px);
        width: 24px;
      }

      .input {
        border-color: #00CC67;
      }
    }

    &-cpf,
    &-zipcode {
      align-items: center;
      display: flex;

      #cpf-search {
        max-width: 200px;
      }

      #zipcode {
        max-width: 100px;

        @media screen and (min-width: 320px) {
          max-width: 147px;
        }

        @media screen and (min-width: 426px) {
          max-width: 200px;
        }
      }

      .help {
        color: #595959;
        font-family: $rubik-font-family;
        font-size: 14px;
        line-height: 20px;
        margin-left: 16px;

        &__link {
          color: #004899;
          font-weight: 500;
          line-height: 24px;
        }

      }

      #cpf ~ .help {
         @media screen and (max-width: 373px) {
          margin-left: 0;
          margin-top: 8px;
         }
      }
    }

    &-cpf {
      @media screen and (max-width: 373px) {
        align-items: start;
        flex-flow: column;
      }
    }
  }
</style>
